import React from 'react';

import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

function TenantInfo (props) {
  const { info = {} } = props;
  const { address = {} } = info;
  return (
    <Grid container>
      <Grid item xs={12}>
        <ListItem>
          <ListItemText primary='Tenant Info' />
        </ListItem>
      </Grid>
      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={6}>
            <ListItem disabled={true}>
              <ListItemText primary='First Name' secondary={address.first_name || '-'} />
            </ListItem>
          </Grid>
          <Grid item x={6}>
            <ListItem disabled={true}>
              <ListItemText primary='Last Name' secondary={address.family_name || '-'} />
            </ListItem>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <List>
          <ListItem disabled={true}>
            <ListItemText primary='Mobile Phone number' secondary={info.phone_number || '-'} />
          </ListItem>
          <ListItem disabled={true}>
            <ListItemText primary='Address Line 1' secondary={address.line1 || '-'} />
          </ListItem>
          <ListItem disabled={true}>
            <ListItemText primary='Address Line 2' secondary={address.line2 || '-'} />
          </ListItem>
          <ListItem disabled={true}>
            <ListItemText primary='City' secondary={address.city || '-'} />
          </ListItem>
          <ListItem disabled={true}>
            <ListItemText primary='Country' secondary={address.country || '-'} />
          </ListItem>
          <ListItem disabled={true}>
            <ListItemText primary='Postal Code' secondary={address.post_code || '-'} />
          </ListItem>
        </List>
      </Grid>
    </Grid>
  );
}

export default React.memo(TenantInfo);
